import { render, staticRenderFns } from "./GuestBooking.vue?vue&type=template&id=bc44b5d0&scoped=true&"
import script from "./GuestBooking.vue?vue&type=script&lang=js&"
export * from "./GuestBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc44b5d0",
  null
  
)

export default component.exports